import React from "react";
import { Control, useWatch } from "react-hook-form";
import {
  Divider,
  ReactSelectController,
  SwitchController,
  Text,
  TextController,
} from "@pushpress/shared-components";
import { AppointmentTypeForm } from "./AppointmentTypeDrawer.types";
import {
  mixedScheduleOptions,
  bufferOptions,
  scheduleMinuteOptions,
} from "./AppointmentTypeDrawer.utils";

interface AppointmentTypeSettingsProps {
  control: Control<AppointmentTypeForm>;
}

function AppointmentTypeSettings(props: AppointmentTypeSettingsProps) {
  const { control } = props;

  const hasNextSteps = useWatch({
    control,
    name: "hasNextSteps",
  });

  return (
    <div className="p-4">
      <Text variant="heading-5" color="wolf-800" weight="600">
        Adjusted availability
      </Text>
      <Text variant="body-md" color="wolf-600" className="mb-3">
        Limit the time slots clients can select when they are self-booking
      </Text>
      <ReactSelectController
        label="Minimum booking notice"
        control={control}
        name="minimumSchedulingNotice"
        required
        options={mixedScheduleOptions}
      />
      <ReactSelectController
        label="Buffer before appointment"
        control={control}
        name="bufferBeforeAppointment"
        required
        options={bufferOptions}
        helperText="Time before your appointment (e.g. setup)"
      />
      <ReactSelectController
        className="mt-3"
        label="Buffer after appointment"
        control={control}
        name="bufferAfterAppointment"
        required
        options={bufferOptions}
        helperText="Time after your appointment (e.g. clean up)"
      />
      <Divider vPadding={24} marginRight={-28} />

      <Text variant="heading-5" color="wolf-800" weight="600">
        Booking settings
      </Text>
      <Text variant="body-md" color="wolf-600" className="mb-3">
        Manage the experience for your clients when they self-book
      </Text>
      <ReactSelectController
        label="Time slot granularity"
        control={control}
        name="availabilityIncrements"
        required
        options={scheduleMinuteOptions}
      />
      <SwitchController
        control={control}
        name="hasNextSteps"
        label="Landing page button"
      />
      <Text variant="body-md" color="wolf-600" className="mb-4">
        Add a configurable button to the booking confirmation page
      </Text>
      {hasNextSteps && (
        <div className="mt-3">
          <TextController
            control={control}
            name="nextStepsLabel"
            label="Button Label"
            required
            autoComplete="off"
          />
          <TextController
            control={control}
            name="nextStepsUrl"
            label="Button URL"
            required
            autoComplete="off"
          />
        </div>
      )}
      <Divider marginRight={-28} />

      <Text variant="heading-5" color="wolf-800" weight="600" className="mt-4">
        Late cancel
      </Text>
      <Text variant="body-md" color="wolf-600" className="mb-3">
        If a client cancels on short-notice, they will lose the session
      </Text>
      <ReactSelectController
        label="Minimum notice to keep session"
        control={control}
        name="lateCancel"
        required
        options={mixedScheduleOptions}
      />
    </div>
  );
}

export default AppointmentTypeSettings;
